module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 16H17V3H16V16H3V17H16V30H17V17H30V16Z\"></path></svg>"